"use client"

import type { StorageAttachmentMeta } from "@/schema"
import { Folder, Link2, Loader2, TriangleAlert, X } from "lucide-react"

interface StorageAttachmentChipProps {
  attachment: StorageAttachmentMeta
  onRemove?: (attachment: StorageAttachmentMeta) => void
}

export function StorageAttachmentChip({ attachment, onRemove }: StorageAttachmentChipProps) {
  const pending = attachment.copy_status === "pending"
  const failed = attachment.copy_status === "failed"

  const Icon = pending ? Loader2 : attachment.kind === "folder" ? Folder : Link2

  return (
    <div
      className="flex h-7 items-center gap-1 rounded-md border px-2 text-xs"
      title={failed ? "Copying failed — linking the original file instead" : `${attachment.provider} link`}
    >
      <Icon className={`size-3 ${pending ? "animate-spin" : ""}`} />
      {pending ? (
        <span className="text-muted-foreground max-w-[140px] truncate">Preparing copy…</span>
      ) : (
        <a
          href={attachment.web_url}
          target="_blank"
          rel="noopener noreferrer"
          className="max-w-[140px] truncate hover:underline"
        >
          {attachment.file_name}
        </a>
      )}
      {failed && <TriangleAlert className="text-yellow-accent size-3" />}
      {onRemove && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation()
            onRemove(attachment)
          }}
          className="text-icon hover:text-destructive ml-0.5 rounded-sm"
        >
          <X className="size-3" />
        </button>
      )}
    </div>
  )
}
